import React, { useContext, useState } from "react";
import {
  Container,
  Nav,
  Popover,
  OverlayTrigger,
  Button,
  Navbar,
  Card,
} from "react-bootstrap";
import { NavLink, Link } from "react-router-dom";
import logo from "../../images/logo.png";
import { UserContext } from "../UserContext";

const Dashboard = (props) => {
  const users = useContext(UserContext);
  function logOut() {
    users.setUser(null);
    localStorage.removeItem("access_token");
  }
  const popover = (
    <Popover id="popover-basic">
      <Popover.Content className="px-0">
        <Link
          className="py-2 px-3 text-decoration-none log-out text-dark d-block"
          onClick={logOut}
          to="#"
        >
          Log Out
        </Link>
        <Link
          className="py-2 px-3 text-decoration-none text-dark log-out d-block"
          to="/packages"
        >
          Add Business
        </Link>
      </Popover.Content>
    </Popover>
  );
  const [side, setSide] = useState(false);
  return (
    <>
      <Container fluid className="p-0">
        <div className="d-flex">
          <div
            className="sidebar-wrapper p-0"
            style={{
              transform: side ? "translateX(0px)" : "",
              zIndex: "200",
            }}
          >
            <Link
              className="navbar-brand bg-white w-100 mb-2 d-flex justify-content-center"
              to="/"
            >
              <img src={logo} alt="logo" height="42px" />
            </Link>
            <Nav defaultActiveKey="/home" className="flex-column">
              <NavLink
                to="/dashboard"
                activeClassName="is-active"
                className="nav-link py-3 "
              >
                <i className="fa fa-home mr-2" />
                Dashboard
              </NavLink>
              <NavLink
                to="/profile"
                className="nav-link py-3 "
                activeClassName="is-active"
              >
                <i className="fa fa-user mr-2 " />
                Profile
              </NavLink>
              <NavLink
                to="/my-listings"
                activeClassName="is-active"
                className="nav-link py-3 "
              >
                <i className="fa fa-list mr-2" />
                My Business
              </NavLink>
              <NavLink
                to="/reviews"
                className="nav-link py-3 "
                activeClassName="is-active"
              >
                <i className="fa fa-list-alt mr-2" aria-hidden="true" />
                Reviews
              </NavLink>
              
              <NavLink
                to="/rate-us"
                className="nav-link py-3 "
                activeClassName="is-active"
              >
                <i className="fa fa-star mr-2" aria-hidden="true" />
                Rate Hubsquares
              </NavLink>
            </Nav>
          </div>

          <div
            className="dash-right"
            onClick={() => (side ? setSide(false) : null)}
          >
            <Navbar
              collapseOnSelect
              expand="lg"
              className="dark navbar-fix"
              variant="dark"
            >
              <Container>
                <Nav className="mr-auto">
                  <i
                    className="fa fa-bars pointer-event text-grey hamb"
                    onClick={() => setSide(!side)}
                  />
                </Nav>
                <Nav>
                  <OverlayTrigger
                    trigger="click"
                    placement="bottom"
                    overlay={popover}
                  >
                    <Button
                      variant="outline-dark dash-btn"
                      className="border-0 "
                    >
                      <i className="fal fa-user-circle text-grey pr-1"></i>
                      {props.user}
                    </Button>
                  </OverlayTrigger>
                </Nav>
              </Container>
            </Navbar>
            <Card.Header className="py-3 mt-head fs-24 font-weight-bold text-new-grey">
              {props.page}
            </Card.Header>
            {props.children}
          </div>
        </div>
      </Container>
    </>
  );
};
export default Dashboard;
